/**
 * Styled Components - Created by david on 10/04/18.
 */
import Modal from 'antd/lib/modal'
import styled from 'styled-components'

export const Container = styled.div`
  background-color: #222;
  font-family: "Avenir Next";
`

export const ModalComponent = styled(Modal)`
  @media (min-width: 481px) {
    #footer-section {
      display: flex;
      align-items: center;
    }
    .button-footer {
      width: 176px;
      height: 44px;
      border-radius: 22px;
      background: #302628;
      color: #FFF;
      text-align: center;
      font-size: 14px;
      font-weight: 600;
      margin-left: 24px;
      cursor: pointer;
      :disabled {
        background: #e8e5e5 !important;
        border: unset;
      }
      :hover {
        background: white;
        color: #302628;
      }
    }
    .cancel-button {
      color: #302628;
      background: #FFF;
      border: 1.5px solid #131112;
      :hover {
        background: #131112;
        color: white;
      }
    }
  }
  @media (max-width: 480px) {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100% !important;
    max-width: unset !important; /* Remove default max-width */
    padding: 0; /* Remove default padding if desired */
    margin: 0px !important;
    .ant-modal-content {
      height: 100%;
      display: flex;
      flex-direction: column;
      @media (max-width: 480px) {
        width: 100%;
        height: 100vh;
      }
    }
    .ant-modal-body {
      flex-grow: 1; /* Allow body to take available space */
      overflow: auto; /* Add scroll if content exceeds screen height */
      padding: 0 !important;
    }
  }
`

export const Text = styled.div`
  color: #fff;
`

export const Title = styled.div`
  color: #302628;
  font-size: 20px;
  font-weight: 600;
  margin-top: 4px;
  margin-left: 4px;
  @media (min-width: 320px) and (max-width: 480px) {
    margin-top: 20px;
    margin-left: 20px;
    font-size: 22px;
  }
`

export const HeadContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  padding-inline-end: 30px;
  #countLabel {
    position: absolute;
    top: 20%;
    left: 11px;
    pointer-events: none;
    color: rgba(0, 0, 0, 0.65);
    z-index: 1;
  }
  @media (min-width: 320px) and (max-width: 480px) {
    flex-direction: column;
    align-items: start;
    margin: 20px;
    padding-inline-end: 0px;
  }
  .ant-input-affix-wrapper .ant-input:not(:last-child) {
    border-radius: 20px !important;
  }
  .ant-input-affix-wrapper {
    max-width: 360px;
    @media (min-width: 320px) and (max-width: 480px) {
      height: 40px;
      margin-top: 12px;
    }
  }
  .ant-input-search:not(.ant-input-search-small) > .ant-input-suffix {
    right: 32px;
  }
  .ant-select-search__field {
    color: white;
    @media (max-width: 698px) {
      visibility: hidden;
    }
  }
  #selected-items {
    margin-left: 8px;
    color: #302628;
    font-size: 14px;
  }
  .category-select {
    position: relative;
    display: inline-block;
  }
  .category-select .ant-select-selection {
    padding-right: 24px !important;
  }
  .category-select::after {
    content: "";
    position: absolute;
    top: 46%;
    left: 44%;
    width: 6px;
    height: 6px;
    border-right: 2px solid #625F5F;
    border-bottom: 2px solid #625F5F;
    transform: translateY(-50%) rotate(45deg);  /* arrow facing down */
    transition: transform 0.2s ease;
    pointer-events: none;
    z-index: 5;
  }
  .category-select.filtered::after {
    left: 74%;
  }
  .category-select.ant-select-open::after, .category-select.ant-select-focused::after {
    transform: translateY(-50%) rotate(-135deg); /* arrow facing up */
  }
  .ant-select-selection--multiple .ant-select-selection__choice {
    display: none !important;
  }
  .ant-select .ant-select-selection {
    color: #625F5F;
    font-size: 14px;
    font-weight: 500;
    border: unset;
    cursor: pointer;
  }
  @media (min-width: 320px) and (max-width: 480px) {
    position: sticky;
    top: -98px;
    z-index: 9;
    background: white;
    padding-bottom: 10px;
    margin-bottom: 0;
    #footer-section {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
    }
    .button-footer {
      width: 100%;
      height: 44px;
      margin-top: 20px;
      border-radius: 22px;
      background: #302628;
      color: #FFF;
      text-align: center;
      font-size: 14px;
      font-weight: 600;
      :disabled {
        background: #e8e5e5 !important;
        border: unset;
      }
      :hover {
        background: white;
      }
    }
    .cancel-button {
      color: #302628;
      background: #FFF;
      border: 1.5px solid #131112;
    }
  }
`

export const List = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding-top: 12px;
  @media (min-width: 320px) and (max-width: 480px) {
    padding-inline: 20px;
    padding-top: 0px;
  }
`

export const ErrorContainer = styled.div`
  display: flex;
  flex: 1;
  height: 60vh;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

export const ErrorTitle = styled.div`
  color: #5f6062;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
`

export const Message = styled.div`
  margin-top: 16px;
  font-size: 16px;
  line-height: 23px;
  text-align: center;
`

export const bodyStyle = { padding: '24px', position: 'relative' }

export const baseButtonStyle = {
  width: '176px',
  height: '40px',
  borderRadius: '22px',
  border: 'unset',
  color: '#FFFFFF',
  background: '#302628',
  fontSize: '14px',
  fontWeight: 600,
  fontFamily: 'Avenir Next',
}

export const okButtonStyle = {...baseButtonStyle }

export const cancelButtonStyle = {
  ...baseButtonStyle,
  background: '#FFFFFF',
  color: '#302628',
  border: '1px solid #302628',
}

export const PaginationRow = styled.div`
  margin-top: 20px;
  width: calc(100% - 20px);
  padding-top: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (min-width: 320px) and (max-width: 698px) {
    padding: 0;
    justify-content: center;
    margin-block: 20px;
    #footer-section {
      display: none;
    }
  }
`

export const NotFound = styled.div`
  font-size: 18px;
  margin-block: 32px;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/LockerModal/styledComponents.tsx